import React from "react";
import styles from "./index.module.less";

function Logo() {
  return <img src="/navigate/images/logo2.png" alt="" className={styles.logoImage} />;
}

export default Logo;
